

















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { VendorEvent, eventStore } from '../store/event-store'
import { firestore, Timestamp } from '../firebase'
import { format } from 'date-fns'
import { foodStore } from '../store/food-store'

@Component
export default class EventEditPage extends Vue {
  eventTitle = '';
  orderStart = '';
  orderEnd = '';
  pickupStart = '';
  pickupEnd = '';
  location = '';
  selectedFood: Array<string> = [];

  get foodList () {
    return foodStore.foodList
  }

  get event () {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return eventStore.events.find(e => e.id === this.$f7route!.params.eventId) || { id: '' }
  }

  @Watch('event', { immediate: true, deep: true })
  onEventChanged (value: VendorEvent) {
    // console.log('event-edit onEventChanged', value, oldValue)
    this.eventTitle = value.title || ''
    this.location = value.location || ''
    this.orderStart = value.orderStart ? format(value.orderStart.toDate(), "yyyy-MM-dd'T'HH:mm") : ''
    this.orderEnd = value.orderEnd ? format(value.orderEnd.toDate(), "yyyy-MM-dd'T'HH:mm") : ''
    this.pickupStart = value.pickupStart ? format(value.pickupStart.toDate(), "yyyy-MM-dd'T'HH:mm") : ''
    this.pickupEnd = value.pickupEnd ? format(value.pickupEnd.toDate(), "yyyy-MM-dd'T'HH:mm") : ''
    this.selectedFood = value.menu?.map(x => firestore.doc(x).id) ?? []
  }

  async saveEvent () {
    // console.log('event-edit saveEvent')
    const updatedEvent: VendorEvent = {
      id: this.event.id,
      title: this.eventTitle,
      location: this.location,
      menu: this.selectedFood
    }

    if (this.orderStart) {
      updatedEvent.orderStart = Timestamp.fromDate(new Date(this.orderStart))
    }
    if (this.orderEnd) {
      updatedEvent.orderEnd = Timestamp.fromDate(new Date(this.orderEnd))
    }
    if (this.pickupStart) {
      updatedEvent.pickupStart = Timestamp.fromDate(new Date(this.pickupStart))
    }
    if (this.pickupEnd) {
      updatedEvent.pickupEnd = Timestamp.fromDate(new Date(this.pickupEnd))
    }

    await eventStore.saveEvent(updatedEvent)

    // eslint-disable-next-line no-unused-expressions
    this.$f7router?.back('/event-list')
  }
}
